import type { ControlType } from "./AnalyticsProvider";
import {
  type Action,
  TrackObject,
  useAnalyticsTracker,
} from "./AnalyticsProvider";

type BaseQuestExtras = {
  id: string;
  gameId?: string;
  gameName?: string;
  questId?: string;
  questType?: string;
  displayOrder?: number;
};

type QuestPressedEvent = {
  action: Action.PRESSED;
  extras: BaseQuestExtras & {
    control: string;
    controlType: ControlType;
    filterValue?: string;
    filterAction?: string;
  };
};

type QuestViewedEvent = {
  action: Action.VIEWED;
  extras: BaseQuestExtras;
};

type QuestSucceededEvent = {
  action: Action.SUCCEEDED;
  extras: BaseQuestExtras;
};

type QuestFailedEvent = {
  action: Action.FAILED;
  extras: BaseQuestExtras;
};

export type QuestEvent =
  | QuestViewedEvent
  | QuestPressedEvent
  | QuestSucceededEvent
  | QuestFailedEvent;

export const useQuestAnalytics = () =>
  useAnalyticsTracker<QuestEvent>(TrackObject.QUESTS);
